// src/components/RPA/buttons/UploadAPConfirmationButton.js
// AP Confirmation Upload (Step 12) — verifies vendor/supplier balances independently
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

const UploadAPConfirmationButton = ({ docId, disabledHint, onDone }) => {
  const [file,      setFile]      = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result,    setResult]    = useState(null);
  const [error,     setError]     = useState(null);

  const downloadTemplate = () => {
    const csv = `Vendor Name,Account Number,Balance Per Books,Balance Per Vendor,Confirmation Date,Response Date,Status,Notes,Confirmation Method
Acme Supplies Inc,AP-001,85000,85000,12/31/2024,01/08/2025,matched,Confirmed via email,positive
TechParts Corp,AP-002,42000,44500,12/31/2024,01/11/2025,exception,Vendor claims additional invoice #INV-889,positive
Office Solutions LLC,AP-003,17500,17500,12/31/2024,01/14/2025,matched,Confirmed via letter,positive`;
    const blob = new Blob([csv], { type: 'text/csv' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href     = url;
    a.download = 'AP_Confirmation_Template.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleUpload = async () => {
    if (!file)  { setError('Please select a file'); return; }
    if (!docId) { setError('No document ID provided'); return; }

    setUploading(true);
    setError(null);

    const formData = new FormData();
    formData.append('apConfirmation', file);

    try {
      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/ap-confirmations/upload`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true
        }
      );
      console.log('[AP_CONF] Success:', res.data);
      setResult(res.data);
      if (onDone) setTimeout(onDone, 2000);
    } catch (err) {
      console.error('[AP_CONF] Error:', err);
      setError(err.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
      <h4 style={{ marginTop: 0, color: '#2c3e50' }}>💳 AP Confirmations (Step 12)</h4>
      <p style={{ fontSize: '14px', color: '#6c757d' }}>
        Upload accounts payable confirmation responses. Verifies vendor balances independently.
      </p>

      {disabledHint && (
        <div style={{ padding: '10px', background: '#fff3cd', borderRadius: '6px', marginBottom: '12px', fontSize: '14px' }}>
          ⚠️ {disabledHint}
        </div>
      )}

      <button
        onClick={downloadTemplate}
        style={{
          padding: '8px 16px', background: '#6c757d', color: 'white',
          border: 'none', borderRadius: '6px', marginBottom: '12px',
          cursor: 'pointer', fontSize: '14px'
        }}
      >
        📄 Download Template
      </button>

      <input
        type="file"
        accept=".csv,.txt"
        onChange={(e) => { setFile(e.target.files[0]); setError(null); setResult(null); }}
        disabled={!!disabledHint || uploading}
        style={{ display: 'block', marginBottom: '12px' }}
      />

      {file && (
        <div style={{ padding: '8px', background: '#e7f3ff', borderRadius: '4px', marginBottom: '12px', fontSize: '13px' }}>
          📎 {file.name}
        </div>
      )}

      <button
        onClick={handleUpload}
        disabled={!file || uploading || !!disabledHint}
        style={{
          padding: '12px 24px',
          background: !file || uploading || disabledHint ? '#ccc' : '#6f42c1',
          color: 'white', border: 'none', borderRadius: '6px',
          cursor: !file || uploading || disabledHint ? 'not-allowed' : 'pointer',
          fontWeight: '600', fontSize: '15px', width: '100%'
        }}
      >
        {uploading ? '⏳ Uploading AP Confirmations...' : '✅ Upload AP Confirmations'}
      </button>

      {error && (
        <div style={{ marginTop: '12px', padding: '12px', background: '#f8d7da', color: '#721c24', borderRadius: '6px', fontSize: '14px' }}>
          ❌ {error}
        </div>
      )}

      {result && (
        <div style={{ marginTop: '12px', padding: '12px', background: '#d4edda', color: '#155724', borderRadius: '6px' }}>
          <strong>✅ AP Confirmations Uploaded Successfully!</strong>
          <div style={{ marginTop: '8px', fontSize: '13px' }}>
            • Total Confirmations: {result.summary?.totalConfirmations || 0}<br/>
            • Matched: {result.summary?.matchedCount || 0}<br/>
            • Exceptions: {result.summary?.exceptionCount || 0}<br/>
            • No Response: {result.summary?.noResponseCount || 0}
              {result.summary?.totalNoResponse > 0 && (
                <span style={{ color: '#856404' }}> (${(result.summary.totalNoResponse).toLocaleString()})</span>
              )}<br/>
            • Total Confirmed: ${(result.summary?.totalConfirmed || 0).toLocaleString()}<br/>
            • Response Rate: {result.summary?.responseRate || 0}%
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadAPConfirmationButton;





// // src/components/RPA/buttons/UploadAPConfirmationButton.js
// // AP Confirmation Upload (Step 12) — verifies vendor/supplier balances independently
// import React, { useState } from 'react';
// import axios from 'axios';

// const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

// const UploadAPConfirmationButton = ({ docId, disabledHint, onDone }) => {
//   const [file,      setFile]      = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [result,    setResult]    = useState(null);
//   const [error,     setError]     = useState(null);

//   const downloadTemplate = () => {
//     const csv = `Vendor Name,Account Number,Balance Per Books,Balance Per Vendor,Confirmation Date,Response Date,Status,Notes,Confirmation Method
// Acme Supplies Inc,AP-001,85000,85000,12/31/2024,01/08/2025,matched,Confirmed via email,positive
// TechParts Corp,AP-002,42000,44500,12/31/2024,01/11/2025,exception,Vendor claims additional invoice #INV-889,positive
// Office Solutions LLC,AP-003,17500,17500,12/31/2024,01/14/2025,matched,Confirmed via letter,positive`;
//     const blob = new Blob([csv], { type: 'text/csv' });
//     const url  = URL.createObjectURL(blob);
//     const a    = document.createElement('a');
//     a.href     = url;
//     a.download = 'AP_Confirmation_Template.csv';
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   const handleUpload = async () => {
//     if (!file)  { setError('Please select a file'); return; }
//     if (!docId) { setError('No document ID provided'); return; }

//     setUploading(true);
//     setError(null);

//     const formData = new FormData();
//     formData.append('apConfirmation', file);

//     try {
//       const res = await axios.post(
//         `${API_URL}/admin/rpa/docs/${docId}/ap-confirmations/upload`,
//         formData,
//         {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           withCredentials: true
//         }
//       );
//       console.log('[AP_CONF] Success:', res.data);
//       setResult(res.data);
//       if (onDone) setTimeout(onDone, 2000);
//     } catch (err) {
//       console.error('[AP_CONF] Error:', err);
//       setError(err.response?.data?.message || 'Upload failed');
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
//       <h4 style={{ marginTop: 0, color: '#2c3e50' }}>💳 AP Confirmations (Step 12)</h4>
//       <p style={{ fontSize: '14px', color: '#6c757d' }}>
//         Upload accounts payable confirmation responses. Verifies vendor balances independently.
//       </p>

//       {disabledHint && (
//         <div style={{ padding: '10px', background: '#fff3cd', borderRadius: '6px', marginBottom: '12px', fontSize: '14px' }}>
//           ⚠️ {disabledHint}
//         </div>
//       )}

//       <button
//         onClick={downloadTemplate}
//         style={{
//           padding: '8px 16px', background: '#6c757d', color: 'white',
//           border: 'none', borderRadius: '6px', marginBottom: '12px',
//           cursor: 'pointer', fontSize: '14px'
//         }}
//       >
//         📄 Download Template
//       </button>

//       <input
//         type="file"
//         accept=".csv,.txt"
//         onChange={(e) => { setFile(e.target.files[0]); setError(null); setResult(null); }}
//         disabled={!!disabledHint || uploading}
//         style={{ display: 'block', marginBottom: '12px' }}
//       />

//       {file && (
//         <div style={{ padding: '8px', background: '#e7f3ff', borderRadius: '4px', marginBottom: '12px', fontSize: '13px' }}>
//           📎 {file.name}
//         </div>
//       )}

//       <button
//         onClick={handleUpload}
//         disabled={!file || uploading || !!disabledHint}
//         style={{
//           padding: '12px 24px',
//           background: !file || uploading || disabledHint ? '#ccc' : '#6f42c1',
//           color: 'white', border: 'none', borderRadius: '6px',
//           cursor: !file || uploading || disabledHint ? 'not-allowed' : 'pointer',
//           fontWeight: '600', fontSize: '15px', width: '100%'
//         }}
//       >
//         {uploading ? '⏳ Uploading AP Confirmations...' : '✅ Upload AP Confirmations'}
//       </button>

//       {error && (
//         <div style={{ marginTop: '12px', padding: '12px', background: '#f8d7da', color: '#721c24', borderRadius: '6px', fontSize: '14px' }}>
//           ❌ {error}
//         </div>
//       )}

//       {result && (
//         <div style={{ marginTop: '12px', padding: '12px', background: '#d4edda', color: '#155724', borderRadius: '6px' }}>
//           <strong>✅ AP Confirmations Uploaded Successfully!</strong>
//           <div style={{ marginTop: '8px', fontSize: '13px' }}>
//             • Total Confirmations: {result.summary?.totalConfirmations || 0}<br/>
//             • Matched: {result.summary?.matchedCount || 0}<br/>
//             • Exceptions: {result.summary?.exceptionCount || 0}<br/>
//             • Response Rate: {result.summary?.responseRate || 0}%
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UploadAPConfirmationButton;